export default __webpack_public_path__ + "static/media/logo-light.c82ad4eb.svg";